/* eslint-disable  @typescript-eslint/no-unused-vars */
/* eslint-disable  @typescript-eslint/no-useless-constructor */
/* eslint-disable  @typescript-eslint/no-redundant-type-constituents */
/* eslint-disable @typescript-eslint/no-extraneous-class */
/* eslint-disable @typescript-eslint/no-empty-object-type */
import { z } from 'zod';
import { validate } from '../../error/validate';
import { enumSchema, domainWsIntervalTypeSchema, type DomainWsIntervalType, localDatetimeSchema, type DomainWsVariantObject, type DomainWsVariantAvailability, type DomainJsonObject, type DomainWspdclasttrans, type DomainWscommitid, } from '../../schema';
import { type WebResponseResult, ValidationError } from '@pdcfrontendui/staffplan';
import { WebRequest } from './WebRequest';
import {
  WebTypeViewField,
  WebField,
  WebRecord,
  WebList,
  WebElement,
  LogonSettings,
  WebSortConfig,
  WebFieldConfig,
  WebListConfig,
  WebRecordType,
  WsRefPerson,
  WsRefOrgunit,
  WsRefOrgunitByInfo,
  WsRefShiftCounter,
  WsRefShifttype,
  WsRefTaskDef,
  WsRefTask,
  WsRefAccount,
  WsRefProject,
  WsRefDimensionItem,
  PersonInfo,
  PersonGroupMember,
  globalSettingsSchema,
  webElementSchema,
  webFieldConfigSchema,
  webFieldSchema,
  webListConfigSchema,
  webListSchema,
  webRecordSchema,
  webRecordTypeSchema,
  webSortConfigSchema,
  webTypeViewFieldSchema,
  wsRefAccountByNameSchema,
  wsRefAccountSchema,
  wsRefDimensionItemByNameSchema,
  wsRefDimensionItemSchema,
  wsRefOrgunitByInfoSchema,
  wsRefOrgunitSchema,
  wsRefPersonByAuxSchema,
  wsRefPersonByNameSchema,
  wsRefPersonBySalaryIdSchema,
  wsRefPersonSchema,
  wsRefProjectByNameSchema,
  wsRefProjectSchema,
  wsRefShiftCounterSchema,
  wsRefShiftDefByExternalIdSchema,
  wsRefShiftDefByIdSchema,
  wsRefShiftDefByNameSchema,
  wsRefShiftDefSchema,
  wsRefShiftTypeByExternalIdSchema,
  wsRefShiftTypeByNameSchema,
  wsRefShifttypeSchema,
  wsRefTaskByExternalIdSchema,
  wsRefTaskByNameSchema,
  wsRefTaskDefByExternalIdSchema,
  wsRefTaskDefByNameSchema,
  wsRefTaskDefSchema,
  wsRefTaskSchema,
  personInfoSchema,
  personGroupMemberSchema,
  globalSettingsJsonSchema,
  webElementJsonSchema,
  webFieldConfigJsonSchema,
  webFieldJsonSchema,
  webListConfigJsonSchema,
  webListJsonSchema,
  webRecordJsonSchema,
  webRecordTypeJsonSchema,
  webSortConfigJsonSchema,
  webTypeViewFieldJsonSchema,
  wsRefAccountByNameJsonSchema,
  wsRefAccountJsonSchema,
  wsRefDimensionItemByNameJsonSchema,
  wsRefDimensionItemJsonSchema,
  wsRefOrgunitByInfoJsonSchema,
  wsRefOrgunitJsonSchema,
  wsRefPersonByAuxJsonSchema,
  wsRefPersonByNameJsonSchema,
  wsRefPersonBySalaryIdJsonSchema,
  wsRefPersonJsonSchema,
  wsRefProjectByNameJsonSchema,
  wsRefProjectJsonSchema,
  wsRefShiftCounterJsonSchema,
  wsRefShiftDefByExternalIdJsonSchema,
  wsRefShiftDefByIdJsonSchema,
  wsRefShiftDefByNameJsonSchema,
  wsRefShiftDefJsonSchema,
  wsRefShiftTypeByExternalIdJsonSchema,
  wsRefShiftTypeByNameJsonSchema,
  wsRefShifttypeJsonSchema,
  wsRefTaskByExternalIdJsonSchema,
  wsRefTaskByNameJsonSchema,
  wsRefTaskDefByExternalIdJsonSchema,
  wsRefTaskDefByNameJsonSchema,
  wsRefTaskDefJsonSchema,
  wsRefTaskJsonSchema,
  personInfoJsonSchema,
  personGroupMemberJsonSchema,
} from './Common_api';
import { PlanEnum, AttendanceClockInOutEnum, TimeAttendanceDeviationEnum, WsAttendanceQueryTypeEnum, TimeAttendanceRefTypeEnum, WsTimeRegEventTypeEnum, UserLoginTypeEnum, MsgVisibilityOldEnum, WebmethodVoidPlaceholderEnum, PlanSchema, AttendanceClockInOutSchema, TimeAttendanceDeviationSchema, WsAttendanceQueryTypeSchema, TimeAttendanceRefTypeSchema, WsTimeRegEventTypeSchema, UserLoginTypeSchema, MsgVisibilityOldSchema, WebmethodVoidPlaceholderSchema, PlanJsonSchema, AttendanceClockInOutJsonSchema, TimeAttendanceDeviationJsonSchema, WsAttendanceQueryTypeJsonSchema, TimeAttendanceRefTypeJsonSchema, WsTimeRegEventTypeJsonSchema, UserLoginTypeJsonSchema, MsgVisibilityOldJsonSchema, WebmethodVoidPlaceholderJsonSchema } from './enumLib_api';
export const msgUserInfoSchema = z.object({
	userId: z.int(),
	userType: UserLoginTypeSchema,
	name: z.string()
});

export const msgUserInfoJsonSchema = z.object({
	userId: z.int(),
	userType: UserLoginTypeJsonSchema,
	name: z.string()
}).describe("Info about a msg user");

/**
	Info about a msg user
	Responsible: JBL, Updated: 20251024
*/
export class MsgUserInfo {
	constructor(
		public userId: number,
		public userType: UserLoginTypeEnum,
		public name: string,
	) {}
}

export const msgEmployeeInfoSchema = z.object({
	personId: z.int(),
	name: z.string()
});

export const msgEmployeeInfoJsonSchema = z.object({
	personId: z.int(),
	name: z.string()
}).describe("Info about a msg employee");

/**
	Info about a msg employee
	Responsible: JBL, Updated: 20260203
*/
export class MsgEmployeeInfo {
	constructor(
		public personId: number,
		public name: string,
	) {}
}

export const msgStaffUserInfoSchema = z.object({
	staffUserId: z.int(),
	name: z.string()
});

export const msgStaffUserInfoJsonSchema = z.object({
	staffUserId: z.int(),
	name: z.string()
}).describe("Info about a msg staff user");

/**
	Info about a msg staff user
	Responsible: JBL, Updated: 20260203
*/
export class MsgStaffUserInfo {
	constructor(
		public staffUserId: number,
		public name: string,
	) {}
}

export const msgPersongroupInfoSchema = z.object({
	persongroupId: z.string(),
	name: z.string()
});

export const msgPersongroupInfoJsonSchema = z.object({
	persongroupId: z.string(),
	name: z.string()
}).describe("Info about a msg person group");

/**
	Info about a msg person group
	Responsible: JBL, Updated: 20260203
*/
export class MsgPersongroupInfo {
	constructor(
		public persongroupId: string,
		public name: string,
	) {}
}

export const msgCommonInfoSchema = z.object({
	msgId: z.int(),
	msgText: z.string(),
	createdWhen: z.coerce.date(),
	senderInfo: z.lazy(() => msgUserInfoSchema),
	isRead: z.boolean()
});

export const msgCommonInfoJsonSchema = z.object({
	msgId: z.int().describe("msg.id"),
	msgText: z.string(),
	createdWhen: z.iso.datetime({ local: true }).describe("msg.created"),
	senderInfo: z.lazy(() => msgUserInfoJsonSchema).describe("msg.creator info"),
	isRead: z.boolean().describe("Is the message read - derived from msgParticipant.displayStatus")
}).describe("Fields that are used in all message types");

/**
	Fields that are used in all message types
	Responsible: JBL, Updated: 20250625
*/
export class MsgCommonInfo {
	constructor(
		/** msg.id */
		public msgId: number,
		public msgText: string,
		/** msg.created */
		public createdWhen: Date,
		/** msg.creator info */
		public senderInfo: MsgUserInfo,
		/** Is the message read - derived from msgParticipant.displayStatus */
		public isRead: boolean,
	) {}
}

export const msgInfoForEmployeeSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoSchema),
	subject: z.string(),
	requiresAcknowledgement: z.boolean()
});

export const msgInfoForEmployeeJsonSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoJsonSchema),
	subject: z.string().describe("msg.subject"),
	requiresAcknowledgement: z.boolean().describe("If true the message should be acknowledged by the user before they can continue using the app")
}).describe("Message type for info messages");

/**
	Message type for info messages
	Responsible: JBL, Updated: 20260204
*/
export class MsgInfoForEmployee {
	constructor(
		public commonInfo: MsgCommonInfo,
		/** msg.subject */
		public subject: string,
		/** If true the message should be acknowledged by the user before they can continue using the app */
		public requiresAcknowledgement: boolean,
	) {}
}

export const msgInfoForStaffuserSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoSchema),
	subject: z.string(),
	isDeletableByUser: z.boolean(),
	hasRecipientsOutsideScope: z.boolean(),
	personGroupRecipientList: z.array(z.string())
});

export const msgInfoForStaffuserJsonSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoJsonSchema),
	subject: z.string().describe("msg.subject"),
	isDeletableByUser: z.boolean().describe("Whether the staffuser retrieving the message has permissions to delete it (Backend still checks access rights)"),
	hasRecipientsOutsideScope: z.boolean().describe("Whether any recipients are outside of the given persongroupid parameter"),
	personGroupRecipientList: z.array(z.string()).describe("The relevant persongroup recipients based on the given parameters")
}).describe("Message type for info messages retrieved by staffusers. Intended for Functionplan.");

/**
	Message type for info messages retrieved by staffusers. Intended for Functionplan.
	Responsible: JBL, Updated: 20260204
*/
export class MsgInfoForStaffuser {
	constructor(
		public commonInfo: MsgCommonInfo,
		/** msg.subject */
		public subject: string,
		/** Whether the staffuser retrieving the message has permissions to delete it (Backend still checks access rights) */
		public isDeletableByUser: boolean,
		/** Whether any recipients are outside of the given persongroupid parameter */
		public hasRecipientsOutsideScope: boolean,
		/** The relevant persongroup recipients based on the given parameters */
		public personGroupRecipientList: string[],
	) {}
}

export const msgDayForEmployeeSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoSchema),
	personId: z.int(),
	day: z.coerce.date()
});

export const msgDayForEmployeeJsonSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoJsonSchema),
	personId: z.int().describe("The person that the day message is for"),
	day: z.iso.datetime({ local: true }).describe("The day that the day message is for")
}).describe("Message type for day messages as seen by employee");

/**
	Message type for day messages as seen by employee
	Responsible: JBL, Updated: 20251024
*/
export class MsgDayForEmployee {
	constructor(
		public commonInfo: MsgCommonInfo,
		/** The person that the day message is for */
		public personId: number,
		/** The day that the day message is for */
		public day: Date,
	) {}
}

export const msgDayForStaffUserSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoSchema),
	personId: z.int(),
	day: z.coerce.date(),
	isPlannerOnly: z.boolean(),
	plannerFollowUp: z.boolean(),
	readByPlannerInfo: z.lazy(() => msgStaffUserInfoSchema).optional().nullable().default(null)
});

export const msgDayForStaffUserJsonSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoJsonSchema),
	personId: z.int().describe("The person that the day message is for"),
	day: z.iso.datetime({ local: true }).describe("The day that the day message is for"),
	isPlannerOnly: z.boolean().describe("False means visible for person and planners with access to the person. True means only visible for planners with access to the person. Comes from from msg.visibility"),
	plannerFollowUp: z.boolean().describe("Should a planner follow up on the message or not. Originates from msgDay.plannerFollowUp and currently comes from msgParticipant.handling"),
	readByPlannerInfo: z.lazy(() => msgStaffUserInfoJsonSchema).optional().nullable().default(null).describe("Info about the (first?) planner that has read the message. In backend, plannerGroup is treated as planner. Unset if no planner has read it yet")
}).describe("Message type for day messages as seen by staffuser");

/**
	Message type for day messages as seen by staffuser
	Responsible: JBL, Updated: 20251024
*/
export class MsgDayForStaffUser {
	constructor(
		public commonInfo: MsgCommonInfo,
		/** The person that the day message is for */
		public personId: number,
		/** The day that the day message is for */
		public day: Date,
		/** False means visible for person and planners with access to the person. True means only visible for planners with access to the person. Comes from from msg.visibility */
		public isPlannerOnly: boolean,
		/** Should a planner follow up on the message or not. Originates from msgDay.plannerFollowUp and currently comes from msgParticipant.handling */
		public plannerFollowUp: boolean,
		/** Info about the (first?) planner that has read the message. In backend, plannerGroup is treated as planner. Unset if no planner has read it yet */
		public readByPlannerInfo: MsgStaffUserInfo | null = null,
	) {}
}

export const msgChatSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoSchema),
	threadId: z.int()
});

export const msgChatJsonSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoJsonSchema),
	threadId: z.int().describe("msg.threadid")
}).describe("Message type for chat messages");

/**
	Message type for chat messages
	Responsible: JBL, Updated: 20250625
*/
export class MsgChat {
	constructor(
		public commonInfo: MsgCommonInfo,
		/** msg.threadid */
		public threadId: number,
	) {}
}

export const msgChatThreadSchema = z.object({
	threadId: z.int(),
	msgChatList: z.array(z.lazy(() => msgChatSchema)),
	toUserList: z.array(z.lazy(() => msgEmployeeInfoSchema)),
	toPersonGroupList: z.array(z.lazy(() => msgPersongroupInfoSchema))
});

export const msgChatThreadJsonSchema = z.object({
	threadId: z.int(),
	msgChatList: z.array(z.lazy(() => msgChatJsonSchema)).describe("chat messages"),
	toUserList: z.array(z.lazy(() => msgEmployeeInfoJsonSchema)).describe("one for each msgParticipant for the thread. plannerGroup is treated as planner."),
	toPersonGroupList: z.array(z.lazy(() => msgPersongroupInfoJsonSchema)).describe("one for each msgPersonGroup for the thread.")
}).describe("Message type for thread messages. Thread participants can not be changed after thread creation");

/**
	Message type for thread messages. Thread participants can not be changed after thread creation
	Responsible: JBL, Updated: 20251024
*/
export class MsgChatThread {
	constructor(
		public threadId: number,
		/** chat messages */
		public msgChatList: MsgChat[],
		/** one for each msgParticipant for the thread. plannerGroup is treated as planner. */
		public toUserList: MsgEmployeeInfo[],
		/** one for each msgPersonGroup for the thread. */
		public toPersonGroupList: MsgPersongroupInfo[],
	) {}
}

export const msgPersonGroupNoteSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoSchema),
	attachmentPeriod: z.object({ from: z.coerce.date(), to: z.coerce.date() }),
	personGroupIdList: z.array(z.string())
});

export const msgPersonGroupNoteJsonSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoJsonSchema),
	attachmentPeriod: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }).describe("The message should be shown with this period"),
	personGroupIdList: z.array(z.string()).describe("The person groups that this note is associated with")
}).describe("Message type for persongroup notes");

/**
	Message type for persongroup notes
	Responsible: JBL, Updated: 20251024
*/
export class MsgPersonGroupNote {
	constructor(
		public commonInfo: MsgCommonInfo,
		/** The message should be shown with this period */
		public attachmentPeriod: DomainWsIntervalType,
		/** The person groups that this note is associated with */
		public personGroupIdList: string[],
	) {}
}

export const msgPersonNoteSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoSchema),
	attachmentPeriod: z.object({ from: z.coerce.date(), to: z.coerce.date() }),
	personid: z.int()
});

export const msgPersonNoteJsonSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoJsonSchema),
	attachmentPeriod: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }),
	personid: z.int().describe("person that this note is associated with")
}).describe("Message type for person notes");

/**
	Message type for person notes
	Responsible: JBL, Updated: 20251024
*/
export class MsgPersonNote {
	constructor(
		public commonInfo: MsgCommonInfo,
		public attachmentPeriod: DomainWsIntervalType,
		/** person that this note is associated with */
		public personid: number,
	) {}
}

export const msgCriticalChangeSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoSchema),
	personId: z.int(),
	affectedPeriod: z.object({ from: z.coerce.date(), to: z.coerce.date() })
});

export const msgCriticalChangeJsonSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoJsonSchema),
	personId: z.int().describe("The person that the critical message is for"),
	affectedPeriod: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })
}).describe("Message type for critical change messages generated by the system");

/**
	Message type for critical change messages generated by the system
	Responsible: JBL, Updated: 20251024
*/
export class MsgCriticalChange {
	constructor(
		public commonInfo: MsgCommonInfo,
		/** The person that the critical message is for */
		public personId: number,
		public affectedPeriod: DomainWsIntervalType,
	) {}
}

export const msgRequestSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoSchema),
	personId: z.int(),
	affectedPeriod: z.object({ from: z.coerce.date(), to: z.coerce.date() })
});

export const msgRequestJsonSchema = z.object({
	commonInfo: z.lazy(() => msgCommonInfoJsonSchema),
	personId: z.int().describe("The person that the request message is for"),
	affectedPeriod: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })
}).describe("Message type for request messages generated by the system");

/**
	Message type for request messages generated by the system
	Responsible: HEBE, Updated: 20260302
*/
export class MsgRequest {
	constructor(
		public commonInfo: MsgCommonInfo,
		/** The person that the request message is for */
		public personId: number,
		public affectedPeriod: DomainWsIntervalType,
	) {}
}

export const msgSyncDeviceSchema = z.object({
	SyncId: z.string()
});

export const msgSyncDeviceJsonSchema = z.object({
	SyncId: z.string().describe("The commitid in the relevant table at the time of the previous call.")
}).describe("Object used for synchronizing messages, by representing when messages were previously retrieved.");

/**
	Object used for synchronizing messages, by representing when messages were previously retrieved.
	Responsible: JBL, Updated: 20251024
*/
export class MsgSyncDevice {
	constructor(
		/** The commitid in the relevant table at the time of the previous call. */
		public SyncId: DomainWscommitid,
	) {}
}

export const msgSyncDeltaSchema = z.object({
	previousSyncDevice: z.lazy(() => msgSyncDeviceSchema),
	currentSyncDevice: z.lazy(() => msgSyncDeviceSchema)
});

export const msgSyncDeltaJsonSchema = z.object({
	previousSyncDevice: z.lazy(() => msgSyncDeviceJsonSchema),
	currentSyncDevice: z.lazy(() => msgSyncDeviceJsonSchema)
}).describe("Used for synchronizing messages. Contains previous and current sync info");

/**
	Used for synchronizing messages. Contains previous and current sync info
	Responsible: JBL, Updated: 20251024
*/
export class MsgSyncDelta {
	constructor(
		public previousSyncDevice: MsgSyncDevice,
		public currentSyncDevice: MsgSyncDevice,
	) {}
}

export const personGroupNoteResultDeltaSchema = z.object({
	updatedPersonGroupNoteList: z.array(z.lazy(() => msgPersonGroupNoteSchema)),
	deletedIdList: z.array(z.int()),
	delta: z.lazy(() => msgSyncDeltaSchema)
});

export const personGroupNoteResultDeltaJsonSchema = z.object({
	updatedPersonGroupNoteList: z.array(z.lazy(() => msgPersonGroupNoteJsonSchema)).describe("New notes"),
	deletedIdList: z.array(z.int()).describe("msg.id of deleted notes"),
	delta: z.lazy(() => msgSyncDeltaJsonSchema).describe("for synchronizing")
}).describe("Changes for person group note retrieval by person groups.");

/**
	Changes for person group note retrieval by person groups.
	Responsible: JBL, Updated: 20251024
*/
export class PersonGroupNoteResultDelta {
	constructor(
		/** New notes */
		public updatedPersonGroupNoteList: MsgPersonGroupNote[],
		/** msg.id of deleted notes */
		public deletedIdList: number[],
		/** for synchronizing */
		public delta: MsgSyncDelta,
	) {}
}

export const personNotesForPersonGroupsDeltaSchema = z.object({
	updatedPersonNoteList: z.array(z.lazy(() => msgPersonNoteSchema)),
	deletedIdList: z.array(z.int()),
	delta: z.lazy(() => msgSyncDeltaSchema)
});

export const personNotesForPersonGroupsDeltaJsonSchema = z.object({
	updatedPersonNoteList: z.array(z.lazy(() => msgPersonNoteJsonSchema)).describe("New person notes"),
	deletedIdList: z.array(z.int()).describe("msg.id of deleted person notes"),
	delta: z.lazy(() => msgSyncDeltaJsonSchema).describe("for synchronizing")
}).describe("Changes for person note retrieval by person groups.");

/**
	Changes for person note retrieval by person groups.
	Responsible: JBL, Updated: 20251024
*/
export class PersonNotesForPersonGroupsDelta {
	constructor(
		/** New person notes */
		public updatedPersonNoteList: MsgPersonNote[],
		/** msg.id of deleted person notes */
		public deletedIdList: number[],
		/** for synchronizing */
		public delta: MsgSyncDelta,
	) {}
}

export const dayMsgForEmployeeDeltaSchema = z.object({
	updatedMsgList: z.array(z.lazy(() => msgDayForEmployeeSchema)),
	deletedMsgIdList: z.array(z.int()),
	delta: z.lazy(() => msgSyncDeltaSchema)
});

export const dayMsgForEmployeeDeltaJsonSchema = z.object({
	updatedMsgList: z.array(z.lazy(() => msgDayForEmployeeJsonSchema)).describe("New day messages"),
	deletedMsgIdList: z.array(z.int()).describe("msg.id of deleted messages"),
	delta: z.lazy(() => msgSyncDeltaJsonSchema).describe("for synchronizing")
}).describe("Changes for getDayMsgForPersonGroups");

/**
	Changes for getDayMsgForPersonGroups
	Responsible: JBL, Updated: 20260130
*/
export class DayMsgForEmployeeDelta {
	constructor(
		/** New day messages */
		public updatedMsgList: MsgDayForEmployee[],
		/** msg.id of deleted messages */
		public deletedMsgIdList: number[],
		/** for synchronizing */
		public delta: MsgSyncDelta,
	) {}
}

export const dayMsgForStaffUserDeltaSchema = z.object({
	updatedMsgList: z.array(z.lazy(() => msgDayForStaffUserSchema)),
	deletedMsgIdList: z.array(z.int()),
	delta: z.lazy(() => msgSyncDeltaSchema)
});

export const dayMsgForStaffUserDeltaJsonSchema = z.object({
	updatedMsgList: z.array(z.lazy(() => msgDayForStaffUserJsonSchema)).describe("New day messages"),
	deletedMsgIdList: z.array(z.int()).describe("msg.id of deleted messages"),
	delta: z.lazy(() => msgSyncDeltaJsonSchema).describe("for synchronizing")
}).describe("Changes for getDayMsgForPersonGroups");

/**
	Changes for getDayMsgForPersonGroups
	Responsible: JBL, Updated: 20251024
*/
export class DayMsgForStaffUserDelta {
	constructor(
		/** New day messages */
		public updatedMsgList: MsgDayForStaffUser[],
		/** msg.id of deleted messages */
		public deletedMsgIdList: number[],
		/** for synchronizing */
		public delta: MsgSyncDelta,
	) {}
}

export const systemMsgForEmployeeDeltaSchema = z.object({
	updatedCriticalChangeMsgList: z.array(z.lazy(() => msgCriticalChangeSchema)),
	updatedRequestMsgList: z.array(z.lazy(() => msgRequestSchema)),
	deletedMsgIdList: z.array(z.int()),
	delta: z.lazy(() => msgSyncDeltaSchema)
});

export const systemMsgForEmployeeDeltaJsonSchema = z.object({
	updatedCriticalChangeMsgList: z.array(z.lazy(() => msgCriticalChangeJsonSchema)).describe("New critical change messages"),
	updatedRequestMsgList: z.array(z.lazy(() => msgRequestJsonSchema)).describe("New request messages"),
	deletedMsgIdList: z.array(z.int()).describe("msg.id of deleted messages"),
	delta: z.lazy(() => msgSyncDeltaJsonSchema).describe("for synchronizing")
}).describe("Changes for system messages");

/**
	Changes for system messages
	Responsible: HEBE, Updated: 20260302
*/
export class SystemMsgForEmployeeDelta {
	constructor(
		/** New critical change messages */
		public updatedCriticalChangeMsgList: MsgCriticalChange[],
		/** New request messages */
		public updatedRequestMsgList: MsgRequest[],
		/** msg.id of deleted messages */
		public deletedMsgIdList: number[],
		/** for synchronizing */
		public delta: MsgSyncDelta,
	) {}
}

export const systemMsgForStaffuserDeltaSchema = z.object({
	updatedCriticalChangeMsgList: z.array(z.lazy(() => msgCriticalChangeSchema)),
	updatedRequestMsgList: z.array(z.lazy(() => msgRequestSchema)),
	deletedMsgIdList: z.array(z.int()),
	delta: z.lazy(() => msgSyncDeltaSchema)
});

export const systemMsgForStaffuserDeltaJsonSchema = z.object({
	updatedCriticalChangeMsgList: z.array(z.lazy(() => msgCriticalChangeJsonSchema)).describe("New critical change messages"),
	updatedRequestMsgList: z.array(z.lazy(() => msgRequestJsonSchema)).describe("New request messages"),
	deletedMsgIdList: z.array(z.int()).describe("msg.id of deleted messages"),
	delta: z.lazy(() => msgSyncDeltaJsonSchema).describe("for synchronizing")
}).describe("Changes for system messages");

/**
	Changes for system messages
	Responsible: HEBE, Updated: 20260302
*/
export class SystemMsgForStaffuserDelta {
	constructor(
		/** New critical change messages */
		public updatedCriticalChangeMsgList: MsgCriticalChange[],
		/** New request messages */
		public updatedRequestMsgList: MsgRequest[],
		/** msg.id of deleted messages */
		public deletedMsgIdList: number[],
		/** for synchronizing */
		public delta: MsgSyncDelta,
	) {}
}

export const receiverGroupSchema = z.object({
	personGroupId: z.string(),
	personIdList: z.array(z.int())
});

export const receiverGroupJsonSchema = z.object({
	personGroupId: z.string(),
	personIdList: z.array(z.int())
}).describe("Receivers for a specific group");

/**
	Receivers for a specific group
	Responsible: JBL, Updated: 20251024
*/
export class ReceiverGroup {
	constructor(
		public personGroupId: string,
		public personIdList: number[],
	) {}
}

export const unreadCountForPersonGroupSchema = z.object({
	persongroupId: z.string(),
	numberOfUnreadMessages: z.int()
});

export const unreadCountForPersonGroupJsonSchema = z.object({
	persongroupId: z.string(),
	numberOfUnreadMessages: z.int()
}).describe("Number of unread day messages for a persongroup");

/**
	Number of unread day messages for a persongroup
	Responsible: JBL, Updated: 20250625
*/
export class UnreadCountForPersonGroup {
	constructor(
		public persongroupId: string,
		public numberOfUnreadMessages: number,
	) {}
}

export const unreadCountAndDateSchema = z.object({
	count: z.int(),
	date: z.coerce.date().optional().nullable().default(null)
});

export const unreadCountAndDateJsonSchema = z.object({
	count: z.int().describe("total number of unread messages"),
	date: z.iso.datetime({ local: true }).optional().nullable().default(null).describe("date of the oldest message counted")
}).describe("unread count and date");

/**
	unread count and date
	Responsible: JBL, Updated: 20260206
*/
export class UnreadCountAndDate {
	constructor(
		/** total number of unread messages */
		public count: number,
		/** date of the oldest message counted */
		public date: Date | null = null,
	) {}
}

export const unreadCountForEmployeeSchema = z.object({
	total: z.int(),
	chatMsgCount: z.int(),
	infoMsgCount: z.int(),
	asapMsgCount: z.lazy(() => unreadCountAndDateSchema),
	noteMsgCount: z.int(),
	dayMsgCount: z.int(),
	systemMsgCount: z.int()
});

export const unreadCountForEmployeeJsonSchema = z.object({
	total: z.int().describe("total number of unread messages"),
	chatMsgCount: z.int().describe("total number of unread chat messages"),
	infoMsgCount: z.int().describe("total number of unread info messages"),
	asapMsgCount: z.lazy(() => unreadCountAndDateJsonSchema).describe("total number of unread asap info messages (subset of the unread info messages) with date of the oldest"),
	noteMsgCount: z.int().describe("total number of unread notes (all types of notes)"),
	dayMsgCount: z.int().describe("total number of unread day messages"),
	systemMsgCount: z.int().describe("total number of unread system messages")
}).describe("Number of unread messages for an employee");

/**
	Number of unread messages for an employee
	Responsible: JBL, Updated: 20260206
*/
export class UnreadCountForEmployee {
	constructor(
		/** total number of unread messages */
		public total: number,
		/** total number of unread chat messages */
		public chatMsgCount: number,
		/** total number of unread info messages */
		public infoMsgCount: number,
		/** total number of unread asap info messages (subset of the unread info messages) with date of the oldest */
		public asapMsgCount: UnreadCountAndDate,
		/** total number of unread notes (all types of notes) */
		public noteMsgCount: number,
		/** total number of unread day messages */
		public dayMsgCount: number,
		/** total number of unread system messages */
		public systemMsgCount: number,
	) {}
}

export const userKeySchema = z.object({
	UserId: z.int(),
	UserType: UserLoginTypeSchema
});

export const userKeyJsonSchema = z.object({
	UserId: z.int(),
	UserType: UserLoginTypeJsonSchema
}).describe("Represents a user (employee or planner)");

/**
	Represents a user (employee or planner)
	Responsible: AGRU, Updated: 20230412
*/
export class UserKey {
	constructor(
		public UserId: number,
		public UserType: UserLoginTypeEnum,
	) {}
}

export const dayMessageSchema = z.object({
	MessageId: z.int(),
	MessageText: z.string(),
	PersonId: z.int(),
	Day: z.coerce.date(),
	FromName: z.string(),
	FromKey: z.lazy(() => userKeySchema),
	SentWhen: z.coerce.date(),
	Visibility: MsgVisibilityOldSchema,
	ReadWhen: z.coerce.date().optional().nullable().default(null)
});

export const dayMessageJsonSchema = z.object({
	MessageId: z.int().describe("msgday.id"),
	MessageText: z.string(),
	PersonId: z.int(),
	Day: z.iso.datetime({ local: true }),
	FromName: z.string(),
	FromKey: z.lazy(() => userKeyJsonSchema),
	SentWhen: z.iso.datetime({ local: true }),
	Visibility: MsgVisibilityOldJsonSchema.describe("Visibility of the message (public, employee or planners only)"),
	ReadWhen: z.iso.datetime({ local: true }).optional().nullable().default(null).describe("When was the message read")
}).describe("A chat message for a specific person / day");

/**
	A chat message for a specific person / day
	Responsible: AGRU, Updated: 20230412
*/
export class DayMessage {
	constructor(
		/** msgday.id */
		public MessageId: number,
		public MessageText: string,
		public PersonId: number,
		public Day: Date,
		public FromName: string,
		public FromKey: UserKey,
		public SentWhen: Date,
		/** Visibility of the message (public, employee or planners only) */
		public Visibility: MsgVisibilityOldEnum,
		/** When was the message read */
		public ReadWhen: Date | null = null,
	) {}
}

export const unreadCountSchema = z.object({
	TeamId: z.string(),
	NumberOfUnreadMessages: z.int()
});

export const unreadCountJsonSchema = z.object({
	TeamId: z.string(),
	NumberOfUnreadMessages: z.int()
}).describe("Number of unread messages for a team");

/**
	Number of unread messages for a team
	Responsible: AGRU, Updated: 20230504
*/
export class UnreadCount {
	constructor(
		public TeamId: string,
		public NumberOfUnreadMessages: number,
	) {}
}

/**
	Fetch info messages for the person in context. Intended for Myplan
	Responsible: JBL, Updated: 20251024
*/
export class GetInfoMsgForEmployee extends WebRequest<MsgInfoForEmployee[]> {
	public readonly webService = "message";
	public readonly method = "GetInfoMsgForEmployee";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public createdSince: Date,
		public createdBefore: Date,
	) {
		super();
	}

	public static readonly create = (x: {createdSince: Date, createdBefore: Date}): GetInfoMsgForEmployee => {
        return new GetInfoMsgForEmployee(x.createdSince, x.createdBefore);
          }
	public static readonly returnSchema = z.array(z.lazy(() => msgInfoForEmployeeSchema));
	public resultFromJSON(json: WebResponseResult<MsgInfoForEmployee[]>): MsgInfoForEmployee[] {
		return validate(GetInfoMsgForEmployee.returnSchema, json) as unknown as MsgInfoForEmployee[];
	}
}

/**
	Fetch info messages for the given persongroups. Intended for FunctionPlan.
	Responsible: JBL, Updated: 20260204
*/
export class GetInfoMsgForPersonGroups extends WebRequest<MsgInfoForStaffuser[]> {
	public readonly webService = "message";
	public readonly method = "GetInfoMsgForPersonGroups";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public createdSince: Date,
		public createdBefore: Date,
		public personGroupIdList: string[],
	) {
		super();
	}

	public static readonly create = (x: {createdSince: Date, createdBefore: Date, personGroupIdList: string[]}): GetInfoMsgForPersonGroups => {
        return new GetInfoMsgForPersonGroups(x.createdSince, x.createdBefore, x.personGroupIdList);
          }
	public static readonly returnSchema = z.array(z.lazy(() => msgInfoForStaffuserSchema));
	public resultFromJSON(json: WebResponseResult<MsgInfoForStaffuser[]>): MsgInfoForStaffuser[] {
		return validate(GetInfoMsgForPersonGroups.returnSchema, json) as unknown as MsgInfoForStaffuser[];
	}
}

/**
	Fetch person group notes for person in context. Intended for Myplan
	Responsible: JBL, Updated: 20260206
*/
export class GetPersonGroupNotesByContextAsEmployee extends WebRequest<MsgPersonGroupNote[]> {
	public readonly webService = "message";
	public readonly method = "GetPersonGroupNotesByContextAsEmployee";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public period: DomainWsIntervalType,
	) {
		super();
	}

	public static readonly create = (x: {period: DomainWsIntervalType}): GetPersonGroupNotesByContextAsEmployee => {
        return new GetPersonGroupNotesByContextAsEmployee(x.period);
          }
	public static readonly returnSchema = z.array(z.lazy(() => msgPersonGroupNoteSchema));
	public resultFromJSON(json: WebResponseResult<MsgPersonGroupNote[]>): MsgPersonGroupNote[] {
		return validate(GetPersonGroupNotesByContextAsEmployee.returnSchema, json) as unknown as MsgPersonGroupNote[];
	}
}

/**
	Fetch person group notes by person groups. Intended for Functionplan
	Responsible: JBL, Updated: 20260206
*/
export class GetPersonGroupNotesByPersonGroupIdListAsEmployee extends WebRequest<PersonGroupNoteResultDelta> {
	public readonly webService = "message";
	public readonly method = "GetPersonGroupNotesByPersonGroupIdListAsEmployee";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public personGroupIdList: string[],
		public period: DomainWsIntervalType,
		public syncDevice: MsgSyncDevice | null = null,
	) {
		super();
	}

	public static readonly create = (x: {personGroupIdList: string[], period: DomainWsIntervalType, syncDevice: MsgSyncDevice | null}): GetPersonGroupNotesByPersonGroupIdListAsEmployee => {
        return new GetPersonGroupNotesByPersonGroupIdListAsEmployee(x.personGroupIdList, x.period, x.syncDevice);
          }
	public static readonly returnSchema = z.lazy(() => personGroupNoteResultDeltaSchema);
	public resultFromJSON(json: WebResponseResult<PersonGroupNoteResultDelta>): PersonGroupNoteResultDelta {
		return validate(GetPersonGroupNotesByPersonGroupIdListAsEmployee.returnSchema, json) as unknown as PersonGroupNoteResultDelta;
	}
}

/**
	Fetch person group notes by person groups. Intended for Functionplan
	Responsible: JBL, Updated: 20260206
*/
export class GetPersonGroupNotesByPersonGroupIdListAsStaffUser extends WebRequest<PersonGroupNoteResultDelta> {
	public readonly webService = "message";
	public readonly method = "GetPersonGroupNotesByPersonGroupIdListAsStaffUser";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public personGroupIdList: string[],
		public period: DomainWsIntervalType,
		public syncDevice: MsgSyncDevice | null = null,
	) {
		super();
	}

	public static readonly create = (x: {personGroupIdList: string[], period: DomainWsIntervalType, syncDevice: MsgSyncDevice | null}): GetPersonGroupNotesByPersonGroupIdListAsStaffUser => {
        return new GetPersonGroupNotesByPersonGroupIdListAsStaffUser(x.personGroupIdList, x.period, x.syncDevice);
          }
	public static readonly returnSchema = z.lazy(() => personGroupNoteResultDeltaSchema);
	public resultFromJSON(json: WebResponseResult<PersonGroupNoteResultDelta>): PersonGroupNoteResultDelta {
		return validate(GetPersonGroupNotesByPersonGroupIdListAsStaffUser.returnSchema, json) as unknown as PersonGroupNoteResultDelta;
	}
}

/**
	Fetch person notes visible to person in context. Intended for Myplan
	Responsible: JBL, Updated: 20260206
*/
export class GetPersonNotesByContextAsEmployee extends WebRequest<MsgPersonNote[]> {
	public readonly webService = "message";
	public readonly method = "GetPersonNotesByContextAsEmployee";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public period: DomainWsIntervalType,
	) {
		super();
	}

	public static readonly create = (x: {period: DomainWsIntervalType}): GetPersonNotesByContextAsEmployee => {
        return new GetPersonNotesByContextAsEmployee(x.period);
          }
	public static readonly returnSchema = z.array(z.lazy(() => msgPersonNoteSchema));
	public resultFromJSON(json: WebResponseResult<MsgPersonNote[]>): MsgPersonNote[] {
		return validate(GetPersonNotesByContextAsEmployee.returnSchema, json) as unknown as MsgPersonNote[];
	}
}

/**
	Fetch person notes for members in the person groups. Intended for Functionplan
	Responsible: JBL, Updated: 20260206
*/
export class GetPersonNotesByPersonGroupIdListAsEmployee extends WebRequest<PersonNotesForPersonGroupsDelta> {
	public readonly webService = "message";
	public readonly method = "GetPersonNotesByPersonGroupIdListAsEmployee";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public personGroupIdList: string[],
		public period: DomainWsIntervalType,
		public syncDevice: MsgSyncDevice | null = null,
	) {
		super();
	}

	public static readonly create = (x: {personGroupIdList: string[], period: DomainWsIntervalType, syncDevice: MsgSyncDevice | null}): GetPersonNotesByPersonGroupIdListAsEmployee => {
        return new GetPersonNotesByPersonGroupIdListAsEmployee(x.personGroupIdList, x.period, x.syncDevice);
          }
	public static readonly returnSchema = z.lazy(() => personNotesForPersonGroupsDeltaSchema);
	public resultFromJSON(json: WebResponseResult<PersonNotesForPersonGroupsDelta>): PersonNotesForPersonGroupsDelta {
		return validate(GetPersonNotesByPersonGroupIdListAsEmployee.returnSchema, json) as unknown as PersonNotesForPersonGroupsDelta;
	}
}

/**
	Fetch person notes for members in the person groups. Intended for Functionplan
	Responsible: JBL, Updated: 20260206
*/
export class GetPersonNotesByPersonGroupIdListAsStaffUser extends WebRequest<PersonNotesForPersonGroupsDelta> {
	public readonly webService = "message";
	public readonly method = "GetPersonNotesByPersonGroupIdListAsStaffUser";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public personGroupIdList: string[],
		public period: DomainWsIntervalType,
		public syncDevice: MsgSyncDevice | null = null,
	) {
		super();
	}

	public static readonly create = (x: {personGroupIdList: string[], period: DomainWsIntervalType, syncDevice: MsgSyncDevice | null}): GetPersonNotesByPersonGroupIdListAsStaffUser => {
        return new GetPersonNotesByPersonGroupIdListAsStaffUser(x.personGroupIdList, x.period, x.syncDevice);
          }
	public static readonly returnSchema = z.lazy(() => personNotesForPersonGroupsDeltaSchema);
	public resultFromJSON(json: WebResponseResult<PersonNotesForPersonGroupsDelta>): PersonNotesForPersonGroupsDelta {
		return validate(GetPersonNotesByPersonGroupIdListAsStaffUser.returnSchema, json) as unknown as PersonNotesForPersonGroupsDelta;
	}
}

/**
	Fetch day messages for person in context. Intended for Myplan
	Responsible: JBL, Updated: 20260130
*/
export class GetDayMsgForEmployee extends WebRequest<DayMsgForEmployeeDelta> {
	public readonly webService = "message";
	public readonly method = "GetDayMsgForEmployee";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public period: DomainWsIntervalType,
		public syncDevice: MsgSyncDevice | null = null,
	) {
		super();
	}

	public static readonly create = (x: {period: DomainWsIntervalType, syncDevice: MsgSyncDevice | null}): GetDayMsgForEmployee => {
        return new GetDayMsgForEmployee(x.period, x.syncDevice);
          }
	public static readonly returnSchema = z.lazy(() => dayMsgForEmployeeDeltaSchema);
	public resultFromJSON(json: WebResponseResult<DayMsgForEmployeeDelta>): DayMsgForEmployeeDelta {
		return validate(GetDayMsgForEmployee.returnSchema, json) as unknown as DayMsgForEmployeeDelta;
	}
}

/**
	Fetch day messages for person groups. Intended for Functionplan and Teamplan
	Responsible: JBL, Updated: 20251024
*/
export class GetDayMsgForPersonGroups extends WebRequest<DayMsgForStaffUserDelta> {
	public readonly webService = "message";
	public readonly method = "GetDayMsgForPersonGroups";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public personGroupIdList: string[],
		public period: DomainWsIntervalType,
		public syncDevice: MsgSyncDevice | null = null,
	) {
		super();
	}

	public static readonly create = (x: {personGroupIdList: string[], period: DomainWsIntervalType, syncDevice: MsgSyncDevice | null}): GetDayMsgForPersonGroups => {
        return new GetDayMsgForPersonGroups(x.personGroupIdList, x.period, x.syncDevice);
          }
	public static readonly returnSchema = z.lazy(() => dayMsgForStaffUserDeltaSchema);
	public resultFromJSON(json: WebResponseResult<DayMsgForStaffUserDelta>): DayMsgForStaffUserDelta {
		return validate(GetDayMsgForPersonGroups.returnSchema, json) as unknown as DayMsgForStaffUserDelta;
	}
}

/**
	Fetch chat messages for person in context. Intended for Myplan
	Responsible: JBL, Updated: 20251024
*/
export class GetChatMsg extends WebRequest<MsgChatThread[]> {
	public readonly webService = "message";
	public readonly method = "GetChatMsg";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public createdSince: Date,
		public createdBefore: Date,
	) {
		super();
	}

	public static readonly create = (x: {createdSince: Date, createdBefore: Date}): GetChatMsg => {
        return new GetChatMsg(x.createdSince, x.createdBefore);
          }
	public static readonly returnSchema = z.array(z.lazy(() => msgChatThreadSchema));
	public resultFromJSON(json: WebResponseResult<MsgChatThread[]>): MsgChatThread[] {
		return validate(GetChatMsg.returnSchema, json) as unknown as MsgChatThread[];
	}
}

/**
	Fetch system messages for person in context. Intended for Myplan and employee-view of function plan
	Responsible: JBL, Updated: 20260302
*/
export class GetSystemMsgForEmployee extends WebRequest<SystemMsgForEmployeeDelta> {
	public readonly webService = "message";
	public readonly method = "GetSystemMsgForEmployee";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public period: DomainWsIntervalType,
		public syncDevice: MsgSyncDevice | null = null,
	) {
		super();
	}

	public static readonly create = (x: {period: DomainWsIntervalType, syncDevice: MsgSyncDevice | null}): GetSystemMsgForEmployee => {
        return new GetSystemMsgForEmployee(x.period, x.syncDevice);
          }
	public static readonly returnSchema = z.lazy(() => systemMsgForEmployeeDeltaSchema);
	public resultFromJSON(json: WebResponseResult<SystemMsgForEmployeeDelta>): SystemMsgForEmployeeDelta {
		return validate(GetSystemMsgForEmployee.returnSchema, json) as unknown as SystemMsgForEmployeeDelta;
	}
}

/**
	Fetch system messages for persons in personGrouplist in period. Intended for Teamplan, and the function plan planner view
	Responsible: JBL, Updated: 20260302
*/
export class GetSystemMsgForStaffuser extends WebRequest<SystemMsgForStaffuserDelta> {
	public readonly webService = "message";
	public readonly method = "GetSystemMsgForStaffuser";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public period: DomainWsIntervalType,
		public persongroupIdList: string[],
		public syncDevice: MsgSyncDevice | null = null,
	) {
		super();
	}

	public static readonly create = (x: {period: DomainWsIntervalType, persongroupIdList: string[], syncDevice: MsgSyncDevice | null}): GetSystemMsgForStaffuser => {
        return new GetSystemMsgForStaffuser(x.period, x.persongroupIdList, x.syncDevice);
          }
	public static readonly returnSchema = z.lazy(() => systemMsgForStaffuserDeltaSchema);
	public resultFromJSON(json: WebResponseResult<SystemMsgForStaffuserDelta>): SystemMsgForStaffuserDelta {
		return validate(GetSystemMsgForStaffuser.returnSchema, json) as unknown as SystemMsgForStaffuserDelta;
	}
}

/**
	Creates an info message. Intended for FunctionPlan.
	Responsible: JBL, Updated: 20260204
*/
export class NewInfoMsg extends WebRequest<MsgInfoForStaffuser> {
	public readonly webService = "message";
	public readonly method = "NewInfoMsg";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public msgSubject: string,
		public msgText: string,
		public toPersonGroupList: string[],
		public priority: boolean | null = null,
	) {
		super();
	}

	public static readonly create = (x: {msgSubject: string, msgText: string, toPersonGroupList: string[], priority: boolean | null}): NewInfoMsg => {
        return new NewInfoMsg(x.msgSubject, x.msgText, x.toPersonGroupList, x.priority);
          }
	public static readonly returnSchema = z.lazy(() => msgInfoForStaffuserSchema);
	public resultFromJSON(json: WebResponseResult<MsgInfoForStaffuser>): MsgInfoForStaffuser {
		return validate(NewInfoMsg.returnSchema, json) as unknown as MsgInfoForStaffuser;
	}
}

/**
	Post a chat message. Intended for Myplan
	Responsible: JBL, Updated: 20251027
*/
export class NewChatMsg extends WebRequest<MsgChatThread> {
	public readonly webService = "message";
	public readonly method = "NewChatMsg";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public msgText: string,
		public toPersonList: number[],
		public toPersonGroupList: string[],
	) {
		super();
	}

	public static readonly create = (x: {msgText: string, toPersonList: number[], toPersonGroupList: string[]}): NewChatMsg => {
        return new NewChatMsg(x.msgText, x.toPersonList, x.toPersonGroupList);
          }
	public static readonly returnSchema = z.lazy(() => msgChatThreadSchema);
	public resultFromJSON(json: WebResponseResult<MsgChatThread>): MsgChatThread {
		return validate(NewChatMsg.returnSchema, json) as unknown as MsgChatThread;
	}
}

/**
	Create reply to colleague chat message. Intended for Myplan
	Responsible: JBL, Updated: 20251027
*/
export class NewChatReply extends WebRequest<MsgChat> {
	public readonly webService = "message";
	public readonly method = "NewChatReply";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public threadId: number,
		public msgText: string,
	) {
		super();
	}

	public static readonly create = (x: {threadId: number, msgText: string}): NewChatReply => {
        return new NewChatReply(x.threadId, x.msgText);
          }
	public static readonly returnSchema = z.lazy(() => msgChatSchema);
	public resultFromJSON(json: WebResponseResult<MsgChat>): MsgChat {
		return validate(NewChatReply.returnSchema, json) as unknown as MsgChat;
	}
}

/**
	Post a day message from the person in context. Intended for Myplan
	Responsible: JBL, Updated: 20251027
*/
export class NewDayMsgAsEmployee extends WebRequest<MsgDayForEmployee> {
	public readonly webService = "message";
	public readonly method = "NewDayMsgAsEmployee";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public msgText: string,
		public day: Date,
		public personId: number,
	) {
		super();
	}

	public static readonly create = (x: {msgText: string, day: Date, personId: number}): NewDayMsgAsEmployee => {
        return new NewDayMsgAsEmployee(x.msgText, x.day, x.personId);
          }
	public static readonly returnSchema = z.lazy(() => msgDayForEmployeeSchema);
	public resultFromJSON(json: WebResponseResult<MsgDayForEmployee>): MsgDayForEmployee {
		return validate(NewDayMsgAsEmployee.returnSchema, json) as unknown as MsgDayForEmployee;
	}
}

/**
	Post a day message about a person as staff user. Intended for Functionplan and Teamplan
	Responsible: JBL, Updated: 20251027
*/
export class NewDayMsgAsStaffUser extends WebRequest<MsgDayForStaffUser> {
	public readonly webService = "message";
	public readonly method = "NewDayMsgAsStaffUser";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public msgText: string,
		public personId: number,
		public day: Date,
		public isPlannerOnly: boolean | null = null,
		public plannerFollowup: boolean | null = null,
	) {
		super();
	}

	public static readonly create = (x: {msgText: string, personId: number, day: Date, isPlannerOnly: boolean | null, plannerFollowup: boolean | null}): NewDayMsgAsStaffUser => {
        return new NewDayMsgAsStaffUser(x.msgText, x.personId, x.day, x.isPlannerOnly, x.plannerFollowup);
          }
	public static readonly returnSchema = z.lazy(() => msgDayForStaffUserSchema);
	public resultFromJSON(json: WebResponseResult<MsgDayForStaffUser>): MsgDayForStaffUser {
		return validate(NewDayMsgAsStaffUser.returnSchema, json) as unknown as MsgDayForStaffUser;
	}
}

/**
	Post a personGroupNote for a list of groups. Intended for Functionplan
	Responsible: JBL, Updated: 20251027
*/
export class NewPersonGroupNote extends WebRequest<MsgPersonGroupNote> {
	public readonly webService = "message";
	public readonly method = "NewPersonGroupNote";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public msgText: string,
		public personGroupIdList: string[],
		public attachmentPeriod: DomainWsIntervalType,
	) {
		super();
	}

	public static readonly create = (x: {msgText: string, personGroupIdList: string[], attachmentPeriod: DomainWsIntervalType}): NewPersonGroupNote => {
        return new NewPersonGroupNote(x.msgText, x.personGroupIdList, x.attachmentPeriod);
          }
	public static readonly returnSchema = z.lazy(() => msgPersonGroupNoteSchema);
	public resultFromJSON(json: WebResponseResult<MsgPersonGroupNote>): MsgPersonGroupNote {
		return validate(NewPersonGroupNote.returnSchema, json) as unknown as MsgPersonGroupNote;
	}
}

/**
	Post a person note for a person. Intended for Functionplan
	Responsible: JBL, Updated: 20251027
*/
export class NewPersonNote extends WebRequest<MsgPersonNote> {
	public readonly webService = "message";
	public readonly method = "NewPersonNote";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public msgText: string,
		public personid: number,
		public attachmentPeriod: DomainWsIntervalType,
	) {
		super();
	}

	public static readonly create = (x: {msgText: string, personid: number, attachmentPeriod: DomainWsIntervalType}): NewPersonNote => {
        return new NewPersonNote(x.msgText, x.personid, x.attachmentPeriod);
          }
	public static readonly returnSchema = z.lazy(() => msgPersonNoteSchema);
	public resultFromJSON(json: WebResponseResult<MsgPersonNote>): MsgPersonNote {
		return validate(NewPersonNote.returnSchema, json) as unknown as MsgPersonNote;
	}
}

/**
	Get list of persons and persongroups that person in context can send chat messages to. Intended for Myplan
	Responsible: JBL, Updated: 20251027
*/
export class GetChatRecipients extends WebRequest<ReceiverGroup[]> {
	public readonly webService = "message";
	public readonly method = "GetChatRecipients";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
	) {
		super();
	}

	public static readonly create = (x: {}): GetChatRecipients => {
        return new GetChatRecipients();
          }
	public static readonly returnSchema = z.array(z.lazy(() => receiverGroupSchema));
	public resultFromJSON(json: WebResponseResult<ReceiverGroup[]>): ReceiverGroup[] {
		return validate(GetChatRecipients.returnSchema, json) as unknown as ReceiverGroup[];
	}
}

/**
	Mark a list of messages as read. Intended to be universal
	Responsible: JBL, Updated: 20250625
*/
export class MarkAsRead extends WebRequest<WebmethodVoidPlaceholderEnum> {
	public readonly webService = "message";
	public readonly method = "MarkAsRead";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public msgIdList: number[],
	) {
		super();
	}

	public static readonly create = (x: {msgIdList: number[]}): MarkAsRead => {
        return new MarkAsRead(x.msgIdList);
          }
	public static readonly returnSchema = WebmethodVoidPlaceholderSchema;
	public resultFromJSON(json: WebResponseResult<WebmethodVoidPlaceholderEnum>): WebmethodVoidPlaceholderEnum {
		return validate(MarkAsRead.returnSchema, json) as unknown as WebmethodVoidPlaceholderEnum;
	}
}

/**
	Set plannerFollowUp of a message. Only used for day messages. Intended for Functionplan
	Responsible: JBL, Updated: 20250625
*/
export class SetPlannerFollowUp extends WebRequest<MsgDayForStaffUser> {
	public readonly webService = "message";
	public readonly method = "SetPlannerFollowUp";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public msgId: number,
		public plannerFollowUp: boolean,
	) {
		super();
	}

	public static readonly create = (x: {msgId: number, plannerFollowUp: boolean}): SetPlannerFollowUp => {
        return new SetPlannerFollowUp(x.msgId, x.plannerFollowUp);
          }
	public static readonly returnSchema = z.lazy(() => msgDayForStaffUserSchema);
	public resultFromJSON(json: WebResponseResult<MsgDayForStaffUser>): MsgDayForStaffUser {
		return validate(SetPlannerFollowUp.returnSchema, json) as unknown as MsgDayForStaffUser;
	}
}

/**
	Get number of unread day messages per persongroup. Intended for Teamplan
	Responsible: JBL, Updated: 20260205
*/
export class GetUnreadDayMessageCountForPersongroup extends WebRequest<UnreadCountForPersonGroup[]> {
	public readonly webService = "message";
	public readonly method = "GetUnreadDayMessageCountForPersongroup";
	public readonly noUserValidation = false;
	public readonly noAuditAction = true;

	constructor(
		public personGroupIdList: string[],
		public period: DomainWsIntervalType,
	) {
		super();
	}

	public static readonly create = (x: {personGroupIdList: string[], period: DomainWsIntervalType}): GetUnreadDayMessageCountForPersongroup => {
        return new GetUnreadDayMessageCountForPersongroup(x.personGroupIdList, x.period);
          }
	public static readonly returnSchema = z.array(z.lazy(() => unreadCountForPersonGroupSchema));
	public resultFromJSON(json: WebResponseResult<UnreadCountForPersonGroup[]>): UnreadCountForPersonGroup[] {
		return validate(GetUnreadDayMessageCountForPersongroup.returnSchema, json) as unknown as UnreadCountForPersonGroup[];
	}
}

/**
	Get number of unread messages of the person separated by message type. Intended for Myplan
	Responsible: JBL, Updated: 20251024
*/
export class GetUnreadCountForEmployee extends WebRequest<UnreadCountForEmployee> {
	public readonly webService = "message";
	public readonly method = "GetUnreadCountForEmployee";
	public readonly noUserValidation = false;
	public readonly noAuditAction = true;

	constructor(
	) {
		super();
	}

	public static readonly create = (x: {}): GetUnreadCountForEmployee => {
        return new GetUnreadCountForEmployee();
          }
	public static readonly returnSchema = z.lazy(() => unreadCountForEmployeeSchema);
	public resultFromJSON(json: WebResponseResult<UnreadCountForEmployee>): UnreadCountForEmployee {
		return validate(GetUnreadCountForEmployee.returnSchema, json) as unknown as UnreadCountForEmployee;
	}
}

/**
	Delete a message. Only used for day messages and notes in FP. Intended for Functionplan
	Responsible: JBL, Updated: 20250625
*/
export class DeleteMessage extends WebRequest<WebmethodVoidPlaceholderEnum> {
	public readonly webService = "message";
	public readonly method = "DeleteMessage";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public msgId: number,
	) {
		super();
	}

	public static readonly create = (x: {msgId: number}): DeleteMessage => {
        return new DeleteMessage(x.msgId);
          }
	public static readonly returnSchema = WebmethodVoidPlaceholderSchema;
	public resultFromJSON(json: WebResponseResult<WebmethodVoidPlaceholderEnum>): WebmethodVoidPlaceholderEnum {
		return validate(DeleteMessage.returnSchema, json) as unknown as WebmethodVoidPlaceholderEnum;
	}
}

/**
	Fetch all day messages for the specified persons and period
	Responsible: AGRU, Updated: 20230424
*/
export class GetMessages extends WebRequest<DayMessage[]> {
	public readonly webService = "message";
	public readonly method = "GetMessages";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public PersonIds: number[],
		public Period: DomainWsIntervalType,
	) {
		super();
	}

	public static readonly create = (x: {PersonIds: number[], Period: DomainWsIntervalType}): GetMessages => {
        return new GetMessages(x.PersonIds, x.Period);
          }
	public static readonly returnSchema = z.array(z.lazy(() => dayMessageSchema));
	public resultFromJSON(json: WebResponseResult<DayMessage[]>): DayMessage[] {
		return validate(GetMessages.returnSchema, json) as unknown as DayMessage[];
	}
}

/**
	Sends a day message from the current user (planner)
	Responsible: AGRU, Updated: 20230412
*/
export class PostMessage extends WebRequest<DayMessage> {
	public readonly webService = "message";
	public readonly method = "PostMessage";
	public readonly noUserValidation = false;
	public readonly noAuditAction = true;

	constructor(
		public PersonId: number,
		public Day: Date,
		public MessageText: string,
		public Visibility: MsgVisibilityOldEnum,
	) {
		super();
	}

	public static readonly create = (x: {PersonId: number, Day: Date, MessageText: string, Visibility: MsgVisibilityOldEnum}): PostMessage => {
        return new PostMessage(x.PersonId, x.Day, x.MessageText, x.Visibility);
          }
	public static readonly returnSchema = z.lazy(() => dayMessageSchema);
	public resultFromJSON(json: WebResponseResult<DayMessage>): DayMessage {
		return validate(PostMessage.returnSchema, json) as unknown as DayMessage;
	}
}

/**
	Mark a list of day messages as read by planner
	Responsible: AGRU, Updated: 20230412
*/
export class MarkMessagesAsRead extends WebRequest<number[]> {
	public readonly webService = "message";
	public readonly method = "MarkMessagesAsRead";
	public readonly noUserValidation = false;
	public readonly noAuditAction = true;

	constructor(
		public MessageIds: number[],
	) {
		super();
	}

	public static readonly create = (x: {MessageIds: number[]}): MarkMessagesAsRead => {
        return new MarkMessagesAsRead(x.MessageIds);
          }
	public static readonly returnSchema = z.array(z.int());
	public resultFromJSON(json: WebResponseResult<number[]>): number[] {
		return validate(MarkMessagesAsRead.returnSchema, json) as unknown as number[];
	}
}

/**
	Get number of unread messages per team
	Responsible: AGRU, Updated: 20230504
*/
export class GetUnreadCounts extends WebRequest<UnreadCount[]> {
	public readonly webService = "message";
	public readonly method = "GetUnreadCounts";
	public readonly noUserValidation = false;
	public readonly noAuditAction = true;

	constructor(
		public TeamIds: string[],
		public Period: DomainWsIntervalType,
	) {
		super();
	}

	public static readonly create = (x: {TeamIds: string[], Period: DomainWsIntervalType}): GetUnreadCounts => {
        return new GetUnreadCounts(x.TeamIds, x.Period);
          }
	public static readonly returnSchema = z.array(z.lazy(() => unreadCountSchema));
	public resultFromJSON(json: WebResponseResult<UnreadCount[]>): UnreadCount[] {
		return validate(GetUnreadCounts.returnSchema, json) as unknown as UnreadCount[];
	}
}

export const GetInfoMsgForEmployeeAI = { key: 'message_GetInfoMsgForEmployee' as const,
          webService: 'message' as const,
           method: 'GetInfoMsgForEmployee' as const,
           description: "Fetch info messages for the person in context. Intended for Myplan",
           inputJsonSchema: z.object({ createdSince: z.iso.datetime({ local: true }), createdBefore: z.iso.datetime({ local: true })}),
           inputSchema: z.object({ createdSince: z.coerce.date(), createdBefore: z.coerce.date()}),
          outputJsonSchema: z.array(z.lazy(() => msgInfoForEmployeeJsonSchema)),
          outputSchema: z.array(z.lazy(() => msgInfoForEmployeeSchema)),
          requestClass: GetInfoMsgForEmployee
          }
export const GetInfoMsgForPersonGroupsAI = { key: 'message_GetInfoMsgForPersonGroups' as const,
          webService: 'message' as const,
           method: 'GetInfoMsgForPersonGroups' as const,
           description: "Fetch info messages for the given persongroups. Intended for FunctionPlan.",
           inputJsonSchema: z.object({ createdSince: z.iso.datetime({ local: true }), createdBefore: z.iso.datetime({ local: true }), personGroupIdList: z.array(z.string())}),
           inputSchema: z.object({ createdSince: z.coerce.date(), createdBefore: z.coerce.date(), personGroupIdList: z.array(z.string())}),
          outputJsonSchema: z.array(z.lazy(() => msgInfoForStaffuserJsonSchema)),
          outputSchema: z.array(z.lazy(() => msgInfoForStaffuserSchema)),
          requestClass: GetInfoMsgForPersonGroups
          }
export const GetPersonGroupNotesByContextAsEmployeeAI = { key: 'message_GetPersonGroupNotesByContextAsEmployee' as const,
          webService: 'message' as const,
           method: 'GetPersonGroupNotesByContextAsEmployee' as const,
           description: "Fetch person group notes for person in context. Intended for Myplan",
           inputJsonSchema: z.object({ period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })}),
           inputSchema: z.object({ period: z.object({ from: z.coerce.date(), to: z.coerce.date() })}),
          outputJsonSchema: z.array(z.lazy(() => msgPersonGroupNoteJsonSchema)),
          outputSchema: z.array(z.lazy(() => msgPersonGroupNoteSchema)),
          requestClass: GetPersonGroupNotesByContextAsEmployee
          }
export const GetPersonGroupNotesByPersonGroupIdListAsEmployeeAI = { key: 'message_GetPersonGroupNotesByPersonGroupIdListAsEmployee' as const,
          webService: 'message' as const,
           method: 'GetPersonGroupNotesByPersonGroupIdListAsEmployee' as const,
           description: "Fetch person group notes by person groups. Intended for Functionplan",
           inputJsonSchema: z.object({ personGroupIdList: z.array(z.string()), period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }), syncDevice: z.lazy(() => msgSyncDeviceJsonSchema).optional().nullable().default(null)}),
           inputSchema: z.object({ personGroupIdList: z.array(z.string()), period: z.object({ from: z.coerce.date(), to: z.coerce.date() }), syncDevice: z.lazy(() => msgSyncDeviceSchema).optional().nullable().default(null)}),
          outputJsonSchema: z.lazy(() => personGroupNoteResultDeltaJsonSchema),
          outputSchema: z.lazy(() => personGroupNoteResultDeltaSchema),
          requestClass: GetPersonGroupNotesByPersonGroupIdListAsEmployee
          }
export const GetPersonGroupNotesByPersonGroupIdListAsStaffUserAI = { key: 'message_GetPersonGroupNotesByPersonGroupIdListAsStaffUser' as const,
          webService: 'message' as const,
           method: 'GetPersonGroupNotesByPersonGroupIdListAsStaffUser' as const,
           description: "Fetch person group notes by person groups. Intended for Functionplan",
           inputJsonSchema: z.object({ personGroupIdList: z.array(z.string()), period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }), syncDevice: z.lazy(() => msgSyncDeviceJsonSchema).optional().nullable().default(null)}),
           inputSchema: z.object({ personGroupIdList: z.array(z.string()), period: z.object({ from: z.coerce.date(), to: z.coerce.date() }), syncDevice: z.lazy(() => msgSyncDeviceSchema).optional().nullable().default(null)}),
          outputJsonSchema: z.lazy(() => personGroupNoteResultDeltaJsonSchema),
          outputSchema: z.lazy(() => personGroupNoteResultDeltaSchema),
          requestClass: GetPersonGroupNotesByPersonGroupIdListAsStaffUser
          }
export const GetPersonNotesByContextAsEmployeeAI = { key: 'message_GetPersonNotesByContextAsEmployee' as const,
          webService: 'message' as const,
           method: 'GetPersonNotesByContextAsEmployee' as const,
           description: "Fetch person notes visible to person in context. Intended for Myplan",
           inputJsonSchema: z.object({ period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })}),
           inputSchema: z.object({ period: z.object({ from: z.coerce.date(), to: z.coerce.date() })}),
          outputJsonSchema: z.array(z.lazy(() => msgPersonNoteJsonSchema)),
          outputSchema: z.array(z.lazy(() => msgPersonNoteSchema)),
          requestClass: GetPersonNotesByContextAsEmployee
          }
export const GetPersonNotesByPersonGroupIdListAsEmployeeAI = { key: 'message_GetPersonNotesByPersonGroupIdListAsEmployee' as const,
          webService: 'message' as const,
           method: 'GetPersonNotesByPersonGroupIdListAsEmployee' as const,
           description: "Fetch person notes for members in the person groups. Intended for Functionplan",
           inputJsonSchema: z.object({ personGroupIdList: z.array(z.string()), period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }), syncDevice: z.lazy(() => msgSyncDeviceJsonSchema).optional().nullable().default(null)}),
           inputSchema: z.object({ personGroupIdList: z.array(z.string()), period: z.object({ from: z.coerce.date(), to: z.coerce.date() }), syncDevice: z.lazy(() => msgSyncDeviceSchema).optional().nullable().default(null)}),
          outputJsonSchema: z.lazy(() => personNotesForPersonGroupsDeltaJsonSchema),
          outputSchema: z.lazy(() => personNotesForPersonGroupsDeltaSchema),
          requestClass: GetPersonNotesByPersonGroupIdListAsEmployee
          }
export const GetPersonNotesByPersonGroupIdListAsStaffUserAI = { key: 'message_GetPersonNotesByPersonGroupIdListAsStaffUser' as const,
          webService: 'message' as const,
           method: 'GetPersonNotesByPersonGroupIdListAsStaffUser' as const,
           description: "Fetch person notes for members in the person groups. Intended for Functionplan",
           inputJsonSchema: z.object({ personGroupIdList: z.array(z.string()), period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }), syncDevice: z.lazy(() => msgSyncDeviceJsonSchema).optional().nullable().default(null)}),
           inputSchema: z.object({ personGroupIdList: z.array(z.string()), period: z.object({ from: z.coerce.date(), to: z.coerce.date() }), syncDevice: z.lazy(() => msgSyncDeviceSchema).optional().nullable().default(null)}),
          outputJsonSchema: z.lazy(() => personNotesForPersonGroupsDeltaJsonSchema),
          outputSchema: z.lazy(() => personNotesForPersonGroupsDeltaSchema),
          requestClass: GetPersonNotesByPersonGroupIdListAsStaffUser
          }
export const GetDayMsgForEmployeeAI = { key: 'message_GetDayMsgForEmployee' as const,
          webService: 'message' as const,
           method: 'GetDayMsgForEmployee' as const,
           description: "Fetch day messages for person in context. Intended for Myplan",
           inputJsonSchema: z.object({ period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }), syncDevice: z.lazy(() => msgSyncDeviceJsonSchema).optional().nullable().default(null)}),
           inputSchema: z.object({ period: z.object({ from: z.coerce.date(), to: z.coerce.date() }), syncDevice: z.lazy(() => msgSyncDeviceSchema).optional().nullable().default(null)}),
          outputJsonSchema: z.lazy(() => dayMsgForEmployeeDeltaJsonSchema),
          outputSchema: z.lazy(() => dayMsgForEmployeeDeltaSchema),
          requestClass: GetDayMsgForEmployee
          }
export const GetDayMsgForPersonGroupsAI = { key: 'message_GetDayMsgForPersonGroups' as const,
          webService: 'message' as const,
           method: 'GetDayMsgForPersonGroups' as const,
           description: "Fetch day messages for person groups. Intended for Functionplan and Teamplan",
           inputJsonSchema: z.object({ personGroupIdList: z.array(z.string()), period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }), syncDevice: z.lazy(() => msgSyncDeviceJsonSchema).optional().nullable().default(null)}),
           inputSchema: z.object({ personGroupIdList: z.array(z.string()), period: z.object({ from: z.coerce.date(), to: z.coerce.date() }), syncDevice: z.lazy(() => msgSyncDeviceSchema).optional().nullable().default(null)}),
          outputJsonSchema: z.lazy(() => dayMsgForStaffUserDeltaJsonSchema),
          outputSchema: z.lazy(() => dayMsgForStaffUserDeltaSchema),
          requestClass: GetDayMsgForPersonGroups
          }
export const GetChatMsgAI = { key: 'message_GetChatMsg' as const,
          webService: 'message' as const,
           method: 'GetChatMsg' as const,
           description: "Fetch chat messages for person in context. Intended for Myplan",
           inputJsonSchema: z.object({ createdSince: z.iso.datetime({ local: true }), createdBefore: z.iso.datetime({ local: true })}),
           inputSchema: z.object({ createdSince: z.coerce.date(), createdBefore: z.coerce.date()}),
          outputJsonSchema: z.array(z.lazy(() => msgChatThreadJsonSchema)),
          outputSchema: z.array(z.lazy(() => msgChatThreadSchema)),
          requestClass: GetChatMsg
          }
export const GetSystemMsgForEmployeeAI = { key: 'message_GetSystemMsgForEmployee' as const,
          webService: 'message' as const,
           method: 'GetSystemMsgForEmployee' as const,
           description: "Fetch system messages for person in context. Intended for Myplan and employee-view of function plan",
           inputJsonSchema: z.object({ period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }), syncDevice: z.lazy(() => msgSyncDeviceJsonSchema).optional().nullable().default(null)}),
           inputSchema: z.object({ period: z.object({ from: z.coerce.date(), to: z.coerce.date() }), syncDevice: z.lazy(() => msgSyncDeviceSchema).optional().nullable().default(null)}),
          outputJsonSchema: z.lazy(() => systemMsgForEmployeeDeltaJsonSchema),
          outputSchema: z.lazy(() => systemMsgForEmployeeDeltaSchema),
          requestClass: GetSystemMsgForEmployee
          }
export const GetSystemMsgForStaffuserAI = { key: 'message_GetSystemMsgForStaffuser' as const,
          webService: 'message' as const,
           method: 'GetSystemMsgForStaffuser' as const,
           description: "Fetch system messages for persons in personGrouplist in period. Intended for Teamplan, and the function plan planner view",
           inputJsonSchema: z.object({ period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) }), persongroupIdList: z.array(z.string()), syncDevice: z.lazy(() => msgSyncDeviceJsonSchema).optional().nullable().default(null)}),
           inputSchema: z.object({ period: z.object({ from: z.coerce.date(), to: z.coerce.date() }), persongroupIdList: z.array(z.string()), syncDevice: z.lazy(() => msgSyncDeviceSchema).optional().nullable().default(null)}),
          outputJsonSchema: z.lazy(() => systemMsgForStaffuserDeltaJsonSchema),
          outputSchema: z.lazy(() => systemMsgForStaffuserDeltaSchema),
          requestClass: GetSystemMsgForStaffuser
          }
export const NewInfoMsgAI = { key: 'message_NewInfoMsg' as const,
          webService: 'message' as const,
           method: 'NewInfoMsg' as const,
           description: "Creates an info message. Intended for FunctionPlan.",
           inputJsonSchema: z.object({ msgSubject: z.string(), msgText: z.string(), toPersonGroupList: z.array(z.string()), priority: z.boolean().optional().nullable().default(null)}),
           inputSchema: z.object({ msgSubject: z.string(), msgText: z.string(), toPersonGroupList: z.array(z.string()), priority: z.boolean().optional().nullable().default(null)}),
          outputJsonSchema: z.lazy(() => msgInfoForStaffuserJsonSchema),
          outputSchema: z.lazy(() => msgInfoForStaffuserSchema),
          requestClass: NewInfoMsg
          }
export const NewChatMsgAI = { key: 'message_NewChatMsg' as const,
          webService: 'message' as const,
           method: 'NewChatMsg' as const,
           description: "Post a chat message. Intended for Myplan",
           inputJsonSchema: z.object({ msgText: z.string(), toPersonList: z.array(z.int()), toPersonGroupList: z.array(z.string())}),
           inputSchema: z.object({ msgText: z.string(), toPersonList: z.array(z.int()), toPersonGroupList: z.array(z.string())}),
          outputJsonSchema: z.lazy(() => msgChatThreadJsonSchema),
          outputSchema: z.lazy(() => msgChatThreadSchema),
          requestClass: NewChatMsg
          }
export const NewChatReplyAI = { key: 'message_NewChatReply' as const,
          webService: 'message' as const,
           method: 'NewChatReply' as const,
           description: "Create reply to colleague chat message. Intended for Myplan",
           inputJsonSchema: z.object({ threadId: z.int(), msgText: z.string()}),
           inputSchema: z.object({ threadId: z.int(), msgText: z.string()}),
          outputJsonSchema: z.lazy(() => msgChatJsonSchema),
          outputSchema: z.lazy(() => msgChatSchema),
          requestClass: NewChatReply
          }
export const NewDayMsgAsEmployeeAI = { key: 'message_NewDayMsgAsEmployee' as const,
          webService: 'message' as const,
           method: 'NewDayMsgAsEmployee' as const,
           description: "Post a day message from the person in context. Intended for Myplan",
           inputJsonSchema: z.object({ msgText: z.string(), day: z.iso.datetime({ local: true }), personId: z.int()}),
           inputSchema: z.object({ msgText: z.string(), day: z.coerce.date(), personId: z.int()}),
          outputJsonSchema: z.lazy(() => msgDayForEmployeeJsonSchema),
          outputSchema: z.lazy(() => msgDayForEmployeeSchema),
          requestClass: NewDayMsgAsEmployee
          }
export const NewDayMsgAsStaffUserAI = { key: 'message_NewDayMsgAsStaffUser' as const,
          webService: 'message' as const,
           method: 'NewDayMsgAsStaffUser' as const,
           description: "Post a day message about a person as staff user. Intended for Functionplan and Teamplan",
           inputJsonSchema: z.object({ msgText: z.string(), personId: z.int(), day: z.iso.datetime({ local: true }), isPlannerOnly: z.boolean().optional().nullable().default(null), plannerFollowup: z.boolean().optional().nullable().default(null)}),
           inputSchema: z.object({ msgText: z.string(), personId: z.int(), day: z.coerce.date(), isPlannerOnly: z.boolean().optional().nullable().default(null), plannerFollowup: z.boolean().optional().nullable().default(null)}),
          outputJsonSchema: z.lazy(() => msgDayForStaffUserJsonSchema),
          outputSchema: z.lazy(() => msgDayForStaffUserSchema),
          requestClass: NewDayMsgAsStaffUser
          }
export const NewPersonGroupNoteAI = { key: 'message_NewPersonGroupNote' as const,
          webService: 'message' as const,
           method: 'NewPersonGroupNote' as const,
           description: "Post a personGroupNote for a list of groups. Intended for Functionplan",
           inputJsonSchema: z.object({ msgText: z.string(), personGroupIdList: z.array(z.string()), attachmentPeriod: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })}),
           inputSchema: z.object({ msgText: z.string(), personGroupIdList: z.array(z.string()), attachmentPeriod: z.object({ from: z.coerce.date(), to: z.coerce.date() })}),
          outputJsonSchema: z.lazy(() => msgPersonGroupNoteJsonSchema),
          outputSchema: z.lazy(() => msgPersonGroupNoteSchema),
          requestClass: NewPersonGroupNote
          }
export const NewPersonNoteAI = { key: 'message_NewPersonNote' as const,
          webService: 'message' as const,
           method: 'NewPersonNote' as const,
           description: "Post a person note for a person. Intended for Functionplan",
           inputJsonSchema: z.object({ msgText: z.string(), personid: z.int(), attachmentPeriod: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })}),
           inputSchema: z.object({ msgText: z.string(), personid: z.int(), attachmentPeriod: z.object({ from: z.coerce.date(), to: z.coerce.date() })}),
          outputJsonSchema: z.lazy(() => msgPersonNoteJsonSchema),
          outputSchema: z.lazy(() => msgPersonNoteSchema),
          requestClass: NewPersonNote
          }
export const GetChatRecipientsAI = { key: 'message_GetChatRecipients' as const,
          webService: 'message' as const,
           method: 'GetChatRecipients' as const,
           description: "Get list of persons and persongroups that person in context can send chat messages to. Intended for Myplan",
           inputJsonSchema: z.object({ }),
           inputSchema: z.object({ }),
          outputJsonSchema: z.array(z.lazy(() => receiverGroupJsonSchema)),
          outputSchema: z.array(z.lazy(() => receiverGroupSchema)),
          requestClass: GetChatRecipients
          }
export const MarkAsReadAI = { key: 'message_MarkAsRead' as const,
          webService: 'message' as const,
           method: 'MarkAsRead' as const,
           description: "Mark a list of messages as read. Intended to be universal",
           inputJsonSchema: z.object({ msgIdList: z.array(z.int())}),
           inputSchema: z.object({ msgIdList: z.array(z.int())}),
          outputJsonSchema: WebmethodVoidPlaceholderJsonSchema,
          outputSchema: WebmethodVoidPlaceholderSchema,
          requestClass: MarkAsRead
          }
export const SetPlannerFollowUpAI = { key: 'message_SetPlannerFollowUp' as const,
          webService: 'message' as const,
           method: 'SetPlannerFollowUp' as const,
           description: "Set plannerFollowUp of a message. Only used for day messages. Intended for Functionplan",
           inputJsonSchema: z.object({ msgId: z.int(), plannerFollowUp: z.boolean()}),
           inputSchema: z.object({ msgId: z.int(), plannerFollowUp: z.boolean()}),
          outputJsonSchema: z.lazy(() => msgDayForStaffUserJsonSchema),
          outputSchema: z.lazy(() => msgDayForStaffUserSchema),
          requestClass: SetPlannerFollowUp
          }
export const GetUnreadDayMessageCountForPersongroupAI = { key: 'message_GetUnreadDayMessageCountForPersongroup' as const,
          webService: 'message' as const,
           method: 'GetUnreadDayMessageCountForPersongroup' as const,
           description: "Get number of unread day messages per persongroup. Intended for Teamplan",
           inputJsonSchema: z.object({ personGroupIdList: z.array(z.string()), period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })}),
           inputSchema: z.object({ personGroupIdList: z.array(z.string()), period: z.object({ from: z.coerce.date(), to: z.coerce.date() })}),
          outputJsonSchema: z.array(z.lazy(() => unreadCountForPersonGroupJsonSchema)),
          outputSchema: z.array(z.lazy(() => unreadCountForPersonGroupSchema)),
          requestClass: GetUnreadDayMessageCountForPersongroup
          }
export const GetUnreadCountForEmployeeAI = { key: 'message_GetUnreadCountForEmployee' as const,
          webService: 'message' as const,
           method: 'GetUnreadCountForEmployee' as const,
           description: "Get number of unread messages of the person separated by message type. Intended for Myplan",
           inputJsonSchema: z.object({ }),
           inputSchema: z.object({ }),
          outputJsonSchema: z.lazy(() => unreadCountForEmployeeJsonSchema),
          outputSchema: z.lazy(() => unreadCountForEmployeeSchema),
          requestClass: GetUnreadCountForEmployee
          }
export const DeleteMessageAI = { key: 'message_DeleteMessage' as const,
          webService: 'message' as const,
           method: 'DeleteMessage' as const,
           description: "Delete a message. Only used for day messages and notes in FP. Intended for Functionplan",
           inputJsonSchema: z.object({ msgId: z.int()}),
           inputSchema: z.object({ msgId: z.int()}),
          outputJsonSchema: WebmethodVoidPlaceholderJsonSchema,
          outputSchema: WebmethodVoidPlaceholderSchema,
          requestClass: DeleteMessage
          }
export const GetMessagesAI = { key: 'message_GetMessages' as const,
          webService: 'message' as const,
           method: 'GetMessages' as const,
           description: "Fetch all day messages for the specified persons and period",
           inputJsonSchema: z.object({ PersonIds: z.array(z.int()), Period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })}),
           inputSchema: z.object({ PersonIds: z.array(z.int()), Period: z.object({ from: z.coerce.date(), to: z.coerce.date() })}),
          outputJsonSchema: z.array(z.lazy(() => dayMessageJsonSchema)),
          outputSchema: z.array(z.lazy(() => dayMessageSchema)),
          requestClass: GetMessages
          }
export const PostMessageAI = { key: 'message_PostMessage' as const,
          webService: 'message' as const,
           method: 'PostMessage' as const,
           description: "Sends a day message from the current user (planner)",
           inputJsonSchema: z.object({ PersonId: z.int(), Day: z.iso.datetime({ local: true }), MessageText: z.string(), Visibility: MsgVisibilityOldJsonSchema}),
           inputSchema: z.object({ PersonId: z.int(), Day: z.coerce.date(), MessageText: z.string(), Visibility: MsgVisibilityOldSchema}),
          outputJsonSchema: z.lazy(() => dayMessageJsonSchema),
          outputSchema: z.lazy(() => dayMessageSchema),
          requestClass: PostMessage
          }
export const MarkMessagesAsReadAI = { key: 'message_MarkMessagesAsRead' as const,
          webService: 'message' as const,
           method: 'MarkMessagesAsRead' as const,
           description: "Mark a list of day messages as read by planner",
           inputJsonSchema: z.object({ MessageIds: z.array(z.int())}),
           inputSchema: z.object({ MessageIds: z.array(z.int())}),
          outputJsonSchema: z.array(z.int()),
          outputSchema: z.array(z.int()),
          requestClass: MarkMessagesAsRead
          }
export const GetUnreadCountsAI = { key: 'message_GetUnreadCounts' as const,
          webService: 'message' as const,
           method: 'GetUnreadCounts' as const,
           description: "Get number of unread messages per team",
           inputJsonSchema: z.object({ TeamIds: z.array(z.string()), Period: z.object({ from: z.iso.datetime({ local: true }), to: z.iso.datetime({ local: true }) })}),
           inputSchema: z.object({ TeamIds: z.array(z.string()), Period: z.object({ from: z.coerce.date(), to: z.coerce.date() })}),
          outputJsonSchema: z.array(z.lazy(() => unreadCountJsonSchema)),
          outputSchema: z.array(z.lazy(() => unreadCountSchema)),
          requestClass: GetUnreadCounts
          }
export const endpoints = [GetInfoMsgForEmployeeAI, GetInfoMsgForPersonGroupsAI, GetPersonGroupNotesByContextAsEmployeeAI, GetPersonGroupNotesByPersonGroupIdListAsEmployeeAI, GetPersonGroupNotesByPersonGroupIdListAsStaffUserAI, GetPersonNotesByContextAsEmployeeAI, GetPersonNotesByPersonGroupIdListAsEmployeeAI, GetPersonNotesByPersonGroupIdListAsStaffUserAI, GetDayMsgForEmployeeAI, GetDayMsgForPersonGroupsAI, GetChatMsgAI, GetSystemMsgForEmployeeAI, GetSystemMsgForStaffuserAI, NewInfoMsgAI, NewChatMsgAI, NewChatReplyAI, NewDayMsgAsEmployeeAI, NewDayMsgAsStaffUserAI, NewPersonGroupNoteAI, NewPersonNoteAI, GetChatRecipientsAI, MarkAsReadAI, SetPlannerFollowUpAI, GetUnreadDayMessageCountForPersongroupAI, GetUnreadCountForEmployeeAI, DeleteMessageAI, GetMessagesAI, PostMessageAI, MarkMessagesAsReadAI, GetUnreadCountsAI] as const;
export type Endpoint = (typeof endpoints)[number];
